(function () {
  "use strict";

  const doc = document.documentElement;

  /* 1. Sticky Add-to-Cart Button */
  document.addEventListener("click", function (event) {
    const button = event.target.closest(".js-sticky-atc");
    if (!button) return;

    const form =
      document.querySelector('form[action*="/cart/add"][method="post"][data-product-form]') ||
      document.querySelector('form[id^="ProductForm-"]') ||
      document.querySelector('form[method="post"][data-type="add-to-cart-form"]') ||
      document.querySelector('form[method="post"][action*="/cart/add"]') ||
      document.querySelector('form[name="product"]');

    if (!form) return;

    const addButton = form.querySelector(
      'button[name="add"][type="submit"], button[type="submit"][name="add"]'
    );

    if (addButton) {
      addButton.click();
    } else {
      HTMLFormElement.prototype.submit.call(form);
    }
  });

  /* 2. Cart Drawer */
  const drawer = document.getElementById("cel-cart-drawer");
  const hasDrawer = Boolean(drawer);
  const statusTextEl = hasDrawer ? drawer.querySelector("[data-cart-status-text]") : null;
  const totalEl = hasDrawer ? drawer.querySelector("[data-cart-total]") : null;
  const mainItemEl = hasDrawer ? drawer.querySelector("[data-cart-main-item]") : null;
  const recosWrap = hasDrawer ? drawer.querySelector("[data-cart-recos]") : null;
  const cartJsonUrl = hasDrawer ? drawer.dataset.cartJsonUrl : "/cart.js";
  const cartAddUrl = hasDrawer ? drawer.dataset.cartAddUrl : "/cart/add.js";
  const recommendationsUrl = hasDrawer
    ? drawer.dataset.recommendationsUrl
    : "/recommendations/products.json";

  let activeCurrency = hasDrawer ? drawer.dataset.currency || "EUR" : "EUR";
  let previouslyFocusedElement = null;
  let previousDocumentOverflow = "";
  let drawerHideTimer = null;

  function getFocusableElements() {
    if (!hasDrawer) return [];
    return Array.from(
      drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return (
        !element.hidden &&
        element.getAttribute("aria-hidden") !== "true" &&
        element.getClientRects().length > 0
      );
    });
  }

  function openCartDrawer(open) {
    if (!hasDrawer) return;

    window.clearTimeout(drawerHideTimer);

    if (open) {
      if (!drawer.classList.contains("is-open")) {
        previouslyFocusedElement = document.activeElement;
        previousDocumentOverflow = doc.style.overflow;
      }
      drawer.hidden = false;
      drawer.inert = false;
      drawer.removeAttribute("inert");
      drawer.setAttribute("aria-hidden", "false");
      drawer.classList.add("is-open");
      doc.style.overflow = "hidden";

      window.requestAnimationFrame(function () {
        const closeButton = drawer.querySelector("button[data-cart-close]");
        if (closeButton) closeButton.focus();
      });
      return;
    }

    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    drawer.inert = true;
    drawer.setAttribute("inert", "");
    doc.style.overflow = previousDocumentOverflow;

    drawerHideTimer = window.setTimeout(function () {
      if (!drawer.classList.contains("is-open")) drawer.hidden = true;
    }, 260);

    if (
      previouslyFocusedElement instanceof HTMLElement &&
      document.contains(previouslyFocusedElement)
    ) {
      previouslyFocusedElement.focus();
    }
    previouslyFocusedElement = null;
  }

  function closeCartDrawer() {
    openCartDrawer(false);
  }

  function formatMoney(cents) {
    if (typeof cents !== "number" || !Number.isFinite(cents)) return "";

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "de-DE", {
        style: "currency",
        currency: activeCurrency,
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2).replace(".", ",") + " " + activeCurrency;
    }
  }

  function safeUrl(value, sameOrigin) {
    if (!value) return null;

    try {
      const url = new URL(value, window.location.origin);
      if (url.protocol !== "http:" && url.protocol !== "https:") return null;
      if (sameOrigin && url.origin !== window.location.origin) return null;
      return sameOrigin ? url.pathname + url.search + url.hash : url.href;
    } catch (error) {
      return null;
    }
  }

  function createTextElement(tagName, className, text) {
    const element = document.createElement(tagName);
    element.className = className;
    element.textContent = text || "";
    return element;
  }

  function updateCartIndicators(cart) {
    if (!cart) return;

    const count = Number(cart.item_count) || 0;
    document.querySelectorAll(".celAct__bubble, .celDrawer__count").forEach(function (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });

    document.querySelectorAll(".celAct__cart, .celDrawer__cart").forEach(function (link) {
      link.setAttribute(
        "aria-label",
        count > 0 ? "Warenkorb, " + count + " Artikel" : "Warenkorb"
      );
    });
  }

  function renderMainItem(addedItem) {
    if (!mainItemEl || !addedItem) return;

    const title = addedItem.product_title || addedItem.title || "";
    const variant = addedItem.variant_title;
    const imageUrl = safeUrl(addedItem.image, false);
    const linePrice =
      addedItem.final_line_price ||
      addedItem.line_price ||
      addedItem.price * addedItem.quantity;
    const line = document.createElement("div");
    line.className = "cel-cart-line";

    if (imageUrl) {
      const media = document.createElement("div");
      const image = document.createElement("img");
      media.className = "cel-cart-line-media";
      image.src = imageUrl;
      image.alt = title;
      image.width = 180;
      image.height = 180;
      media.appendChild(image);
      line.appendChild(media);
    }

    const info = document.createElement("div");
    info.className = "cel-cart-line-info";
    info.appendChild(createTextElement("p", "cel-cart-line-title", title));

    if (variant && variant !== "Default Title") {
      info.appendChild(createTextElement("p", "cel-cart-line-variant", variant));
    }

    info.appendChild(
      createTextElement("p", "cel-cart-line-price", formatMoney(linePrice || addedItem.price))
    );
    line.appendChild(info);
    mainItemEl.replaceChildren(line);
  }

  function renderRecommendations(recommendations) {
    if (!recosWrap) return;
    recosWrap.replaceChildren();

    if (!recommendations || !Array.isArray(recommendations.products)) return;

    recommendations.products.slice(0, 4).forEach(function (product) {
      const productUrl = safeUrl(
        product.url || (product.handle ? "/products/" + product.handle : ""),
        true
      );
      if (!productUrl) return;

      const imageUrl = safeUrl(
        (product.featured_image && product.featured_image.url) ||
          (product.images && product.images[0] && product.images[0].src),
        false
      );
      const link = document.createElement("a");
      link.className = "cel-cart-reco-item";
      link.href = productUrl;

      const media = document.createElement("div");
      media.className = "cel-cart-reco-media";
      if (imageUrl) {
        const image = document.createElement("img");
        image.src = imageUrl;
        image.alt = product.title || "";
        image.width = 54;
        image.height = 54;
        image.loading = "lazy";
        media.appendChild(image);
      }

      const main = document.createElement("div");
      main.className = "cel-cart-reco-main";
      main.appendChild(createTextElement("p", "cel-cart-reco-title", product.title));

      const meta = document.createElement("div");
      meta.className = "cel-cart-reco-meta";
      meta.appendChild(createTextElement("p", "cel-cart-reco-price", formatMoney(product.price)));

      link.append(media, main, meta);
      recosWrap.appendChild(link);
    });
  }

  function renderCartDrawer(addedItem, cart, recommendations) {
    if (!hasDrawer) return;

    if (cart && cart.currency) activeCurrency = cart.currency;

    if (cart && statusTextEl) {
      const count = Number(cart.item_count) || 0;
      statusTextEl.textContent =
        count === 1
          ? "1 Artikel in deinem Warenkorb"
          : count > 1
            ? count + " Artikel in deinem Warenkorb"
            : "Artikel wurde in deinen Warenkorb gelegt";
    }

    if (cart && totalEl) totalEl.textContent = formatMoney(Number(cart.total_price) || 0);

    renderMainItem(addedItem);
    renderRecommendations(recommendations);
    updateCartIndicators(cart);
  }

  async function fetchCart() {
    const response = await fetch(cartJsonUrl, {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("Cart request failed");
    return response.json();
  }

  async function fetchRecommendations(productId) {
    if (!productId) return null;

    try {
      const url = new URL(recommendationsUrl, window.location.origin);
      url.searchParams.set("product_id", productId);
      url.searchParams.set("limit", "4");
      const response = await fetch(url.toString(), {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return null;
      return response.json();
    } catch (error) {
      return null;
    }
  }

  async function handleAddToCart(form) {
    if (!hasDrawer) {
      HTMLFormElement.prototype.submit.call(form);
      return;
    }

    try {
      const response = await fetch(cartAddUrl, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
      });

      if (!response.ok) {
        HTMLFormElement.prototype.submit.call(form);
        return;
      }

      const addedItem = await response.json();
      const cart = await fetchCart();
      const recommendations = await fetchRecommendations(addedItem.product_id);

      renderCartDrawer(addedItem, cart, recommendations);
      openCartDrawer(true);
    } catch (error) {
      HTMLFormElement.prototype.submit.call(form);
    }
  }

  function isProductForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    const action = form.getAttribute("action") || "";
    return (
      action.includes("/cart/add") ||
      form.matches('form[method="post"][data-type="add-to-cart-form"]') ||
      form.getAttribute("name") === "product"
    );
  }

  document.addEventListener("submit", function (event) {
    const form = event.target;
    if (!isProductForm(form)) return;
    event.preventDefault();
    handleAddToCart(form);
  });

  if (hasDrawer) {
    drawer.addEventListener("click", function (event) {
      if (event.target.closest("[data-cart-close]")) {
        event.preventDefault();
        closeCartDrawer();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (!drawer.classList.contains("is-open")) return;

      if (event.key === "Escape") {
        event.preventDefault();
        closeCartDrawer();
        return;
      }

      if (event.key !== "Tab") return;

      const focusableElements = getFocusableElements();
      if (!focusableElements.length) {
        event.preventDefault();
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    });
  }
})();
